import { CruiseDates } from 'components/CruiseDatesFilter/CruiseDates';
import { FilterTabOption } from 'components/CruiseSearchWidget/types';
import { Tabs } from 'components/FiltersModal/Tabs/Tabs';
import { useTabs } from 'components/FiltersModal/Tabs/useTabs';
import { CalendarType } from 'index';
import styles from './FilterDateRange.css';

export function FilterDateRange() {
	const { tabsOptions, activeTab, setActiveTab } = useTabs();
	const getCalendarType = (tab: FilterTabOption | undefined) => {
		if (tab?.value === CalendarType.Dates) return CalendarType.Dates;
		return CalendarType.Months;
	};

	return (
		<div className={styles.root}>
			{tabsOptions && activeTab && <Tabs options={tabsOptions} activeTab={activeTab} onTabClicked={setActiveTab} />}
			<CruiseDates calendarType={getCalendarType(activeTab)} />
		</div>
	);
}
